/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import QUERY, {
	type RoadmapPageLoaderQuery,
} from '@jira/project-settings__board-settings-roadmap/src/__generated__/RoadmapPageLoaderQuery.graphql';
import type { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist
import { createAri } from '@jira/platform__utils-ari/src/index.tsx';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_BOARD_CONTEXT_ROADMAP_SETTINGS } from './resourceTypeRoadmap.constants.tsx';

export const roadmapSettingsResource: RouteResource<
	PreloadedQuery<RoadmapPageLoaderQuery, Record<string, unknown>>
> = createRelayResource<RoadmapPageLoaderQuery>({
	type: RESOURCE_TYPE_BOARD_CONTEXT_ROADMAP_SETTINGS,
	getQuery: ({ match }, { tenantContext }) => {
		const { cloudId } = tenantContext;
		return {
			parameters: QUERY,
			variables: {
				sourceAri: createAri({
					resourceOwner: 'jira-software',
					cloudId,
					resourceType: 'board',
					resourceId: String(match.params.boardId),
				}),
				locationAri: undefined,
			},
			options: { fetchPolicy: 'store-and-network' },
		};
	},
});
